import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const SendIcon = ({
  color, cursor, fillOpacity, ...props
}) => (
  <svg
    {...helpers.getSvgDimensionsProps(props)}
    {...props}
    style={{ cursor }}
  >
    <path
      fill={color}
      d="M0 18L21 9L0 0V7L15 9L0 11V18Z"
    />
  </svg>
);

SendIcon.propTypes = {
  cursor: string,
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

SendIcon.defaultProps = {
  fillOpacity: 0.4,
  cursor: 'inherit',
  ...helpers.getDefaultIconDimensionsProps(21, 18),
};

export default SendIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/send.js